import { useToast } from '@barfacil/barfacil-ui'
import { InfiniteData, useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import {
  PriceListResponse,
  UpdatePriceListBody,
  UpdatePriceListParams,
} from '@/api/_schemas/management'
import { updatePriceList } from '@/api/management'
import { ApiError } from '@/config/api'
import { keyStore } from '@/config/key-store'
import { queryClient } from '@/config/query-client'
import { handleErrors } from '@/services/fetch'

export const useUpdatePriceList = () => {
  const { toastDestructive, toastPositive } = useToast()

  const mutation = useMutation({
    mutationFn: async ({
      id,
      ...data
    }: UpdatePriceListBody & UpdatePriceListParams) =>
      await updatePriceList(data, { id }),
    onSuccess: (updatedItem, params) => {
      queryClient
        .getQueryCache()
        .findAll({
          predicate: ({ queryKey }) =>
            Array.isArray(queryKey) &&
            [...keyStore.priceList.configureInfinite.queryKey].includes(
              queryKey[0],
            ),
        })
        .forEach(({ queryKey }) => {
          queryClient.setQueryData<InfiniteData<PriceListResponse>>(
            queryKey,
            (oldData) =>
              oldData && {
                ...oldData,
                pages: oldData.pages.map(({ data, meta }) => ({
                  data: data.map((item) =>
                    item.cod_lista_preco !== params.id ? item : updatedItem,
                  ),
                  meta,
                })),
              },
          )
        })

      queryClient.refetchQueries({
        queryKey: [...keyStore.priceList.infinite.queryKey],
        exact: false,
      })

      toastPositive('Lista de preço alterada com sucesso!')
    },
    onError: ({ response }: AxiosError<ApiError>) => {
      handleErrors(response?.data, [], toastDestructive)
    },
  })

  return { mutation }
}
